import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload } from './utils'

export const getMasterDataSchema = (tableName, pageNumber = 1, pageSize = 5) => {
  // /api/portal/master/schema/{tableName}
  const url = `${API_ROOT}/portal/master/schema/${tableName}?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

export const searchMasterDataBy = (request) => {
  // /api/portal/master/search
  const url = `${API_ROOT}/portal/master/search`
  return doPost(url, request)
}

export const addMasterDataBy = (request) => {
  // /api/portal/master/save
  const url = `${API_ROOT}/portal/master/save`
  return doPut(url, request)
}

export const deleteMasterDataBy = (tableName, id) => {
  // /api/portal/master/{tableName}/{id}
  const url = `${API_ROOT}/portal/master/${tableName}/${id}`
  return doDelete(url)
}
